export enum SwitchItemPosition {
    LEFT = "LEFT",
    CENTER = "CENTER",
    RIGHT = "RIGHT",
}
